import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import IndexHome from "./pages/IndexHome";

function App() {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<IndexHome />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
